export interface WicketUserActivity {
  type: WickeUserActivityType;
  properties: ContentWatchActivity;
}

export type WickeUserActivityType = 'event.watch';

export interface ContentWatchActivity {
  sessionId: string;
  eventTitle: string;
  eventType: string;
  watchTime: number;
  eventId: string;
  eventFormatAvailability: 'free' | 'subscription' | null;
  applicationCode: string;
}
